// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-dropzone[data-v-11aa2ace]{height:100%;width:100%;min-height:40px!important;border:0;padding:0;position:absolute}.vue-dropzone[data-v-11aa2ace]:hover{background:#fff}.vue-dropzone .dz-message[data-v-11aa2ace]{margin:0}", ""]);
// Exports
module.exports = exports;
